const donationForm = document.getElementById( 'donate-full' )

function donationFormInfo() {
  const radios = [...donationForm.querySelectorAll( '[data-toggle-info] input[type="radio"]' )]
  const infoElements = [...donationForm.querySelectorAll( '[data-toggle-info] p small' )]

  const [radio1, radio2] = radios;
  const [info1, info2] = infoElements;

  const checkCurrentDonationType = () => {
    const selectedRadio = radios.find( radio => radio.checked );
    const amountDifferent = donationForm.querySelector( '#amount_anders' );
    const amountDifferentField = donationForm.querySelector( '#anders' );

    if (amountDifferent.checked) {
      amountDifferentField.closest( '.vvd-form--form__field' ).style.display = 'block';
      amountDifferentField.setAttribute( 'aria-hidden', 'false' );
      amountDifferentField.setAttribute( 'required', 'required' );
    } else {
      amountDifferentField.closest( '.vvd-form--form__field' ).style.display = 'none';
      amountDifferentField.setAttribute( 'aria-hidden', 'true' );
      amountDifferentField.removeAttribute( 'required' );
    }

    if (selectedRadio === radio1) {
      info1.removeAttribute( 'hidden' );
      info2.setAttribute( 'hidden', true );
    } else if (selectedRadio === radio2) {
      info1.setAttribute( 'hidden', true );
      info2.removeAttribute( 'hidden' );
    } else {
      info1.setAttribute( 'hidden', true );
      info2.setAttribute( 'hidden', true );
    }
  }

  donationForm.addEventListener( 'change', () => checkCurrentDonationType() );
  donationForm.addEventListener( 'invalid', () => {
    console.log( 'invalid' );
  } );

  checkCurrentDonationType();
}

export default {
  init() {
    if (donationForm) {
      donationFormInfo()
    }
  }
}

